<template>
  <nav :class="sysPlatform()">
			<div class="wrapper">
				<div class="wrap">
					<div class="logo">
                        <img src="@/assets/images/logo_h.svg">
					</div>
                    <div class="back" @click="back"></div>
					<ul class="nav">
						<li @click="$router.push('/')" :class="[{'active':$route.name=='home'}]">{{$t('home')}}</li>
						<li @click="$router.push('/products')" :class="[{'active':$route.name=='products'}]">{{$t('products')}}</li>
						<li @click="$router.push('/service')" :class="[{'active':$route.name=='service'}]">{{$t('service')}}</li>
						<li @click="$router.push('/about')" :class="[{'active':$route.name=='about'}]">{{$t('about')}}</li>
					</ul>
				</div>
				<div class="lang" @click="languageChange"><img src="@/assets/images/language.svg" width="20"><p>{{language=='zh_CN'?'繁体中文':'EN'}}</p></div>
			</div>
            
		</nav>
</template>

<script>
import '@/assets/css/base.css';
	import '@/utils/rem.js';
	import { useRoute,useRouter } from 'vue-router';
	import { defineComponent, reactive,toRefs } from "vue";
	import { useStore } from "vuex";
	import { useI18n } from 'vue-i18n';
    import {sysPlatform} from "@/utils/util";
    import { callNative } from '@/plugins/jsBridge';
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  setup(){
    const $i18n = useI18n();
    const {t} = useI18n();
    const $store = useStore();
    const $route = useRoute();
    const $router = useRouter();
    const state = reactive({
        language:'zh_CN',
        langObj:{},
        platform:'',
        louis:null,
        versionInfo:{
            ios:"https://apps.apple.com/cn/app/suixinliao/id6468228611",
            android:"",
            googleplay:"https://play.google.com/store/apps/details?id=com.okchat.global"
        }
    });
    
    const languageChange = ()=>{
        let targetLang = '';
        if($i18n.locale.value=='zh_CN'){
            targetLang = 'en_US';
        }else{
            targetLang = 'zh_CN';
        }
        state.language = targetLang;
        $i18n.locale.value = state.language;
        localStorage.setItem("language",state.language);
    }

    const back=()=>{
        if($route.name=='agreement'||$route.name=='privacy'){
            $router.back();
        }else{
           
                callNative("close", {
                    count:0
                })
                .then(async (res) => {

                })
                .catch(async (err) => {
                    console.log(err)
                });
        }
    }

    return {
        ...toRefs(state),
        languageChange,
        sysPlatform,
        back
    }
  }
};
</script>
<style lang="scss" scoped>
	nav{
        position: fixed;
        //top: 0;
        z-index: 999;
        width: 100%;
        height: 54px;
        border-bottom: 1px solid rgba($color: #fff, $alpha: 0.1);
        background-color: rgba($color: #000422, $alpha: .5);

        /* top: constant(safe-area-inset-top); /* 兼容 iOS<11.2 
        top: env(safe-area-inset-top); /* 兼容iOS>= 11.2 */ 
        top: calc(constant(safe-area-inset-top)); /* Older iOS */
      top: calc(env(safe-area-inset-top)); /* Newer iOS */
        .wrapper{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .2rem 0;
            color: #fff;
            .wrap{				
                display: flex;
                justify-content: space-between;
                align-items: center;
                .logo{
                    width: 3.2rem;
                    height: .5rem;
                }
                .back{
                    display: none;
                }
                .nav{
                    width: 420px;
                    margin-left: 1.6rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 15px;
                    li{
                        cursor: pointer;
                    }
                    li.active{
                        position: relative;                        
                        &::after{
                            width: .3rem;
                            height: 3px;
                            position: absolute;
                            left: 50%;
                            bottom: -.3rem;
                            transform: translateX(-50%);
                            display: block;
                            content: "";
                            background-color: #34ca77;
                        }
                    }
                }
            }
            .lang{
                line-height: 30px;
                //border: 1px solid #43e39a;
                border-radius: 5px;
                padding: 0 10px;
                cursor: pointer;
                img{
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                    width: .56rem;
                }
                p{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 15px;
                }
            }
        }
    }

    /*mobile*/
    @media screen and (max-width: 1024px) {
        nav {
            height: .88rem;
            padding: 0;
            border: 0;
            background: none;
            &.android{
                top: .6rem;
            }
            .wrapper {
                padding: .2rem .3rem;
                .logo{display: none;}
                .back{
                    width: .6rem;
                    height: .6rem;
                    border-radius: 50%;
                    display: block !important;
                    background: #021a3f url(@/assets/images/back.svg) no-repeat center /70%;
                }
                .wrap .nav{
                    display: none;
                }
            }
        }
    }
</style>
